import { render, staticRenderFns } from "./FormBodyEditor.vue?vue&type=template&id=e6d4868e&scoped=true&"
import script from "./FormBodyEditor.vue?vue&type=script&lang=js&"
export * from "./FormBodyEditor.vue?vue&type=script&lang=js&"
import style0 from "./FormBodyEditor.vue?vue&type=style&index=0&id=e6d4868e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d4868e",
  null
  
)

export default component.exports